import { Suspense, lazy } from 'react';

import { useContactComposerStore } from '../../state/contact-composer.store';

/**
 * Mount point for the floating contact composer — rendered once in `AppLayout`,
 * beside the call widget, so an open composer survives route changes.
 *
 * Lazy on purpose. The window pulls in both compose views, and through the email
 * one the rich-text editor and the email-render package; a static import here
 * would put all of that in the main chunk on every route, for a feature most
 * page loads never open.
 */
const ContactComposerWindow = lazy(() =>
    import('./contact-composer-window').then((m) => ({ default: m.ContactComposerWindow })),
);

export function ContactComposerMount() {
    const session = useContactComposerStore((s) => s.session);
    if (!session) return null;

    return (
        <Suspense fallback={null}>
            {/* Keyed on the contact: opening the composer for someone else gets
                a clean slate rather than a manual state reset. */}
            <ContactComposerWindow key={session.contactId} contactId={session.contactId} />
        </Suspense>
    );
}
